export default __webpack_public_path__ + "static/media/Video_4.3c5ebb6e.mp4";